import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../../config/core.httpclient-utils';

import { GfTranslateService } from '../../../services/core.translate.service';
import { UiService } from '../../../services/core.ui.service';
import { SettingService } from '../../../services/core.setting.service';
import { StateService } from '@uirouter/angular';
import { FilterService } from '../../../services/core.filter.service';
import { GroupsHelper } from '../../../services/core.groups.helper';
import { AdminService } from '../../../services/core.admin.service';

import * as $ from 'jquery';
import * as _ from 'lodash-es';
import { GfTitleService } from '../../../services/core.title.service';

@Component({
    selector: 'adminGroupsView',
    template: require('./admin.groups.component.html')
})
export class AdminGroupViewComponent implements OnInit {
    search: string;
    loading = false;

    @Input() project: any = null;
    @Input() scm: any = null;
    @Input() projectMenu: any = null;

    sort = {};
    paging: any = {};
    sortFields = { id: 'Join Date', firstname: 'Group Name', unixName: 'Unix Name' };
    currentGroup: any = null;
    checkingUserName = false;
    userNameUnique = false;
    groupMembers = [];
    originalMembersGroup: any = false;
    addUser: any = {
        searchItemsResult: [],
        autoSubmitTimer: null
    };
    groups: any = false;
    newGroup: any = {};
    groupEditActiveTab = 'group-edit-tab-main';
    errors: any = {};
    filters: any = {};
    page = 0;

    editUdfLabels: any = {};
    udfLabels: any = {
        userText1: "UDF 1",
        userText2: "UDF 2",
        userText3: "UDF 3",
        userText4: "UDF 4",
        userText5: "UDF 5",
        userText6: "UDF 6"
    };

    statuses = {
        '-1': 'Pending Approval',
        '0': 'Pending',
        '1': 'Active',
        '2': 'Deleted',
        '3': 'Suspended'
    };

    statusOptions = Object.keys(this.statuses).reduce((carry, k) => {
        carry.push({ id: k, label: this.statuses[k]});
        return carry;
    }, []);

    constructor(
        private adminService: AdminService,
        private $window: Window,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService,
        private httpClient: HttpClient,
        private settingService: SettingService,
        private stateService: StateService, 
        
        private filterService: FilterService,
        private groupsHelper: GroupsHelper,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        this.titleService.setTitle('Site Admin', 'Groups');

        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();

        this.settingService.fetch('site', 0, 'group_udfs', null)
        .then((ret: any) => {
            if (!_.isEmpty(ret.settingValue)) {
                this.udfLabels.userText1 = !_.isEmpty(ret.settingValue.userText1) ? ret.settingValue.userText1 : this.udfLabels.userText1;
                this.udfLabels.userText2 = !_.isEmpty(ret.settingValue.userText2) ? ret.settingValue.userText2 : this.udfLabels.userText2;
                this.udfLabels.userText3 = !_.isEmpty(ret.settingValue.userText3) ? ret.settingValue.userText3 : this.udfLabels.userText3;
                this.udfLabels.userText4 = !_.isEmpty(ret.settingValue.userText4) ? ret.settingValue.userText4 : this.udfLabels.userText4;
                this.udfLabels.userText5 = !_.isEmpty(ret.settingValue.userText5) ? ret.settingValue.userText5 : this.udfLabels.userText5;
                this.udfLabels.userText6 = !_.isEmpty(ret.settingValue.userText6) ? ret.settingValue.userText6 : this.udfLabels.userText6;
            }

            this.editUdfLabels = _.cloneDeep(this.udfLabels);
        });

        this.setFilterValues();
        this.getGroups();

        this.errors = this.groupsHelper.resetErrors();
    };

    onApplyFilters = () => {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters = () => {
        this.resetFilters();
        this.applyFilters();
    };

    onSetSort = (params) => {
        this.sort = {
            sort_field: _.get(params, 'key', 'id'),
            sort_dir: _.get(params, 'sortDir', 'asc')
        };
        this.applyFilters();
    };

    setGroupEditActiveTab = (activeTab) => {
        this.groupEditActiveTab = activeTab;
    };

    formatUnixName = (group) => {
        group.unixName = _.get(group, 'unixName', '').toLowerCase().replace(/\s/, '');
    };

    prepareEditModal = (group) => {
        var promises = [], promiseUser, promiseGroups;

        promiseUser = this.adminService.getUser(group.unixName);
        promiseUser.catch(() => {
            this.uiService.message.showError('There was an error loading the group members.',
                'User');
        });

        this.groupMembers = [];
        promiseGroups = this.adminService.groupUsers(group.unixName);
        promiseGroups.catch(() => {
            this.groupMembers = [];
            this.uiService.message.showError('There was an error loading the group members.',
                'Group Members');
        });

        promises.push(promiseUser, promiseGroups);

        Promise.all(promises)
        .then((response) => {
            //process group response
            this.setCurrentGroup(response[0]);

            //process group response
            this.groupMembers = response[1].items;
            this.originalMembersGroup = _.cloneDeep(this.groupMembers);
        });
    };

    setCurrentGroup = (group) => {
        this.currentGroup = _.cloneDeep(group);
        this.addUser.search = '';
        this.addUser.searchItemsResult = [];
    };

    deleteGroupUser = (user) => {
        var _index = _.findIndex(this.groupMembers, (item: any) => {
            if (item.id == user.id) {
                return true;
            }
            return false;
        });
        this.groupMembers.splice(_index, 1);
    };

    processGroupUpdate = () => {
        let group: any = {
            userId: this.currentGroup.id,
            group_id: this.currentGroup.id,
            unixName: this.currentGroup.unixName.toLowerCase(),
            name: this.currentGroup.firstname,
            status: this.currentGroup.status,
            userText1: this.currentGroup.userText1,
            userText2: this.currentGroup.userText2,
            userText3: this.currentGroup.userText3,
            userText4: this.currentGroup.userText4,
            userText5: this.currentGroup.userText5,
            userText6: this.currentGroup.userText6,
            user_ids: (_.map(this.groupMembers, 'id')).join(',')
        };

        if (!this.groupsHelper.validateGroup(group, this.errors)) {
            this.uiService.message.showError('User group validation failed', 'Add Group');
            return;
        }

        this.adminService.  updateGroup(group.userId, group)
        .then((response) => {
            ($('#group-edit-modal') as any).modal('hide');
            this.applyFilters();
            this.uiService.message.showSuccess('Group succesfuly updated.', 'Update Group');
        }, (response) => {
            this.uiService.message.showError('There was an error saving the group.', 'Update Group');
        });
    };

    removeGroup = () => {
        this.adminService.deleteGroup(this.currentGroup.id)
        .then(() => {
            ($('#group_delete_modal') as any).modal('hide');
            this.applyFilters();
            this.uiService.message.showSuccess('Group succesfuly removed.', 'Remove Group');
        }, () => {
            this.uiService.message.showError('There was an error removing the group.', 'Remove Group');
        });
    };

    cleanNewGroup = () => {
        this.newGroup = {};
    };

    valid = () => {
        return this.newGroup.unixName && this.newGroup.firstname;
    };

    processGroupAdd = () => {
        var params: any =  {
            unixName: this.newGroup.unixName.toLowerCase(),
            name: this.newGroup.firstname
        };

        if (!this.groupsHelper.validateGroup(params, this.errors)) {
            this.uiService.message.showError('User group validation failed', 'Add Group');
            return;
        }

        this.adminService.createGroup(0, params)
        .then(() => {
            ($('#group-add-modal') as any).modal('hide');
            this.cleanNewGroup();
            this.applyFilters();
            this.uiService.message.showSuccess('Group succesfuly added.', 'Add Group');
        }, (response) => {
            ($('#group-add-modal') as any).modal('hide');
            this.cleanNewGroup();
            if (response.status == 400) {
                this.uiService.message.showError('There was an error adding the group. The Unix Name is already taken.', 'Add Group');
            } else {
                this.uiService.message.showError('There was an error adding the group. ' + response.data, 'Add Group');
            }
        });
    };

    addUserAutoSubmit = (searchValue) => {
        console.log("addUserAutoSubmit", searchValue);
        if (this.addUser.autoSubmitTimer) {
            clearTimeout(this.addUser.autoSubmitTimer);
            this.addUser.autoSubmitTimer = null;
        }
        this.addUser.autoSubmitTimer = setTimeout(() => {
            this.addUserSearch(searchValue);
        }, 750);
    };

    addUserToGroup = (item) => {
        this.addUser.search = '';
        this.addUser.searchItemsResult = [];
        item.id = item.refId;
        item.unixName = item.refId;
        item.firstname = item.description;

        this.groupMembers.splice(0, 0, item);
    };

    addUserSearch = (searchValue) => {
        this.addUser.searchItemsResult = [];

        if (searchValue.length < 3) {
            return;
        }

        this.addUser.searching = true;

        const params = {
            q: searchValue,
            s: 'user',
            page_num: 1,
            page_size: 20
        };

        console.log('addUserSearch', params);

        doGetPromise(
            this.httpClient,
            '/api/search/', 
            params
        ).then((response) => {
                this.addUser.searchItemsResult = _.sortBy(
                    _.get(response, 'items', []),
                    ['matchScore', 'title']
                ).reverse();
                this.addUser.searching = false;
        }).catch(() => {
            var errorMsg = this.gfTranslateService.translate('Sorry, {{searchValue}} does not exists'
                , { 'searchValue': searchValue });
            var errorMsgTitle = this.gfTranslateService.translate('Invalid User');
            this.uiService.message.showWarning(errorMsg, errorMsgTitle);
            this.addUser.searching = false;
            this.addUser.search = '';
        });
    };

    cancelUDFSettingsEdit = () => {
        this.editUdfLabels = _.cloneDeep(this.udfLabels);
    }

    saveUDFSettings = () => {
        this.settingService.post(
            { settingName: 'group_udfs', section: 'site', refId: 0, settingValue: this.editUdfLabels }
        ).then(() => {
            this.uiService.message.showSuccess('User defined fields for groups were successfully saved.',
                'Group User Defined Fields');

            this.udfLabels = _.cloneDeep(this.editUdfLabels);
        })
        .catch(() => {
            this.uiService.message.showError('There was an error saving the user defined fields for groups.',
                'Group User Defined Fields');
        })
        .finally(() => {
            ($('#group-udf-edit-modal') as any).modal('hide');
        });
    };

    onPaging = (params) => {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    getGroups = () => {
        this.groups = false;

        var fetchArgs = _.pickBy(
            this.stateService.params,
            (value) => (value != null) && !_.isObject(value)  && (typeof value !== 'function')
        );
        fetchArgs.group = 1; //Only groups

        this.adminService.users(fetchArgs)
        .then((response) => {
            this.groups = _.get(response, 'items', []);
        }, (response) => {
            console.log(response);
            this.groups = [];
        });
    }

    setFilterValues() {
        this.filters = {
            main_fields: this.filterService.setFilterValues(this.getBaseFilters(), this.stateService.params)
        };
    }

    applyFilters = (overrides = {}) => {
        var newParams = _.pickBy(Object.assign(
            { unixName: this.stateService.params.unixName },
            this.sort,
            this.paging,
            this.filterService.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        ), (value) => {
            return (undefined != value && null != value && value != '');
        });

        this.stateService.go('.', newParams, { notify: true, inherit: false, location: 'replace' }).then(this.getGroups);
    }

    resetFilters = () => {
        this.page = 1;

        this.sort = {
            sort_field: 'id',
            sort_dir: 'desc'
        };

        this.filters = {
            main_fields: this.getBaseFilters()
        };
    }

    getBaseFilters() {
        return [
            { alias: "text", fieldName: "Group Search", value: "", fieldType: 4, isExtraField: false }
        ];
    }
}